<template>
  <div class="navBar">
    <MdNavBar class="MD"/>
    <PcNavBar class="PC"/>
  </div>
</template>

<script>
import MdNavBar from './MdNavBar.vue'
import PcNavBar from './PcNavBar.vue'
export default {
  name: 'navBar',
  components: {
    PcNavBar,
    MdNavBar
  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.navBar{
background: #FFFFFF;
}
.image{
  width: 100%;
  height: 100%;
}

// 移动
@media only screen and (max-width: 750px) {
  .PC{
      display: none;
    }
//  .navBar{
//     // height:130px;
//       position: relative;
//     .navBarM{
//       height:130px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     padding-left: 50px;
//     padding-right: 40px;
//     z-index: 9999;
//     }
//     // 标题图片
//     .navBarImg{
//       width: 208.04px;
//       height: 48.01px;
//     }
//     // 汉堡按钮
//     .hanbaocaidan{
//       width: 40px;
//       height: 40px;
//     }
//     // 导航
//     .navBarList{
//       width: 530px;
//       background: #F4F8FB;
//       position:absolute;
//       .navBarItem{
//         // top: 0;
//         width: 530px;
//         height: 108px;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         border: 1px solid #E1E8ED;
//         .top{
//           width: 100%;
//            display: flex;
//            align-items: center;
//            justify-content: space-between;
//            padding: 0 40px;
//           .text{
//             font-size: 30px;
//             color: #333333;
//           }
//           .icon{
//             width: 40px;
//             height: 40px;
//           }
//         }

//       }
//     }
//     // 遮罩曾
//     .mask{
//       position: fixed;
//       top: 130px;
//       right: 0;
//       bottom: 0;
//       left: 0;
//       background-color: #000000;
//       opacity: 0.5
//     }
//  }
}
// pc端
@media only screen and (min-width: 756px) {
  .MD{
    display: none;
  }
//   // 小标题
//     .pciTitle{
//       display: flex;
//       justify-content: flex-end;
//       margin-right: 318px*$sun;
//       margin-top: 6px*$sun;
//       font-size: 16px*$sun;
//       color: #8B8B8B;
//     }
//   .navBarM{
//     height: 103px *$sun;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-size: 20px*$sun;
//     // 标题图片
//     .navBarImg{
//       width: 147.55px*$sun;
//       height: 34.05px*$sun;
//       margin-right: 285px*$sun;
//     }
//     // 标题文字
//     .navBarList{
//       display: flex;
//       justify-content: space-between;
//       .navBarItem{
//         margin-right: 60px*$sun;
//       }
//     }

//  }
}
</style>
